<style scoped>
.main-left-advertisement {
    padding-right: 2%;
}

@screen sm {
    ::v-deep .in-page-advertisement-wrapper {
        padding-left: 5%;
        padding-right: 5%;
    }
}
</style>

<template>
    <div>
        <template v-if="!beyondSalesPeriod">
            <Announcement />
            <section class="my-4">
                <div class="flex flex-row my-2">
                    <Advertisement
                        class="hidden sm:flex w-1/4 main-left-advertisement"
                        :advrtType="'product'"
                        :showPauseBtn="false"
                    />
                    <Advertisement
                        class="w-full sm:w-3/4"
                        :advrtType="'main'"
                        :showPauseBtn="false"
                    />
                </div>
                <ProductList :list="productList" />
                <div class="flex">
                    <bubble class="mx-auto">
                        <template #image>
                            <img :src="sentimentImg" class="w-12 sm:w-20" />
                        </template>
                        <msgSlot :msgKey="bubbleMsgKey" class="sm:text-2xl">
                            <template
                                v-for="(g, gi) in productGroups"
                                v-slot:[g.slotname]
                            >
                                <router-link
                                    :key="gi"
                                    tag="button"
                                    :to="
                                        $store.getters.productGroupRoute(
                                            g.saleCatgSlctCode
                                        )
                                    "
                                    active-class="font-black"
                                    class="text-blue underline"
                                >
                                    <!-- {{ $t(`product.title.${g.name}`) }} -->
                                    {{ g.saleCatgSlctDesp }}
                                </router-link>
                            </template>
                        </msgSlot>
                    </bubble>
                </div>
                <BannerAdvertisement
                    class="mt-2"
                    type="inPage"
                    :fillImgHeight="true"
                />
            </section>
        </template>
        <template v-else>
            <BeyondSalesPeriod />
        </template>
    </div>
</template>

<script>
import Announcement from '../../components/announcement.vue';
import BeyondSalesPeriod from './BeyondSalesPeriod';
import Advertisement from '../../components/advertisement.vue';
import shuffle from 'lodash/shuffle';
import ProductList from '../../components/productList.vue';
import BannerAdvertisement from '../../components/bannerAdvertisement.vue';
import bubble from '../../components/bubble.vue';
import msgSlot from '../../components/msgSlot';
import img4s112 from '../../assets/img/4-112.png';

export default {
    name: 'home',
    components: {
        Announcement,
        BeyondSalesPeriod,
        Advertisement,
        ProductList,
        BannerAdvertisement,
        bubble,
        msgSlot
    },
    created() {
        this.sentimentImg = img4s112;
    },
    computed: {
        productList() {
            const getActualRmnQty = this.$store.getters
                .productActualRemainingQty;
            const productList = this.$store.getters.productList;
            const charityProductList = this.$store.getters.charityProductList;
            const standardProductList = this.$store.getters.standardProductList;
            const sampleProductList = this.$store.getters.sampleProductList;

            const productsWithEmptyStock = productList.filter(
                p => getActualRmnQty(p) <= 0
            );
            const charityProductsWithStock = charityProductList.filter(
                p => getActualRmnQty(p) > 0
            );
            const nonCharityProductsWithStock = standardProductList
                .concat(sampleProductList)
                .filter(p => getActualRmnQty(p) > 0);

            return [
                nonCharityProductsWithStock,
                charityProductsWithStock,
                productsWithEmptyStock
            ]
                .reduce((a, c) => {
                    return a.concat(shuffle(c));
                }, [])
                .filter(product => product.dispProdInd === 'Y')
                .slice(0, 12);
        },
        productListSaleCatgDisplayList() {
            return this.$store.getters.productListSaleCatgDisplayList || [];
        },
        productGroups() {
            return this.productListSaleCatgDisplayList.map((c, i) => ({
                saleCatgSlctDesp: c.saleCatgSlctDesp,
                saleCatgSlctCode: c.saleCatgSlctCode,
                slotname: `slot${i}`
            }));
        },
        bubbleMsgKey() {
            //e.g. length : 5 => result: "{0} {1} {2} {3} {4}"
            const slotsMsg = Array.from(
                { length: this.productListSaleCatgDisplayList.length },
                (_, i) => `{${i}}`
            ).join(' ');
            return `入嚟 ${slotsMsg} 專頁，仲有更多正嘢等緊您`;
        },
        previewCmpyToken() {
            return this.$store.getters.previewCmpyToken;
        },
        beyondSalesPeriod() {
            return this.$store.getters.productList.length === 0;
        }
    }
};
</script>
